module.exports = __webpack_public_path__ + "static/img/wuxian-3.c9f2428a.png";